import React from 'react';
import { ActivityIndicator, Text, View } from 'react-native';

export const RNCenterLoading = ({ error }) => {
    return (
        <View
            style={{
                width: '100%',
                height: '100%',
                justifyContent: 'center',
                alignItems: 'center',
            }}>
            {error ? (
                <Text>{error}</Text>
            ) : (
                <ActivityIndicator color={'#6e6e6e'} />
            )}
        </View>
    );
};
